namespace GeniuzPOS.Purchase {
    export class PoInvoiceReceiveDtColumns {
        static columnsKey = 'Purchase.PoInvoiceReceiveDt';
    }
}
